import React, { Component, Fragment } from 'react';
import { isNullOrEmpty } from '../../helpers/LanguageHelpers';

import './CadeAnalyze.css';

class CadeAnalyzeRaterComments extends Component {

    render() {
        // Multiple blocks below because of react fragments.  Dup
        return (
            <Fragment>
                <h4>Rater Comments</h4>
                
                {this.props.showR1Comments == true && !isNullOrEmpty(this.props.r1Name) &&
                    <h6>{this.props.r1Name} Comments</h6>
                }
                {this.props.showR1Comments == true && !isNullOrEmpty(this.props.r1Name) &&
                    <p className="cadeAnalyze_raterComment">{this.props.r1Comments}</p>
                }

                {this.props.showR2Comments == true && !isNullOrEmpty(this.props.r2Name) &&
                    <h6>{this.props.r2Name} Comments</h6>
                }
                {this.props.showR2Comments == true && !isNullOrEmpty(this.props.r2Name) &&
                    <p className="cadeAnalyze_raterComment">{this.props.r2Comments}</p>
                }

                {this.props.showCgComments == true && !isNullOrEmpty(this.props.cgName) &&
                    <h6>{this.props.cgName} Comments</h6>
                }
                {this.props.showCgComments == true && !isNullOrEmpty(this.props.cgName) &&
                    <p className="cadeAnalyze_raterComment">{this.props.cgComments}</p>
                }

            </Fragment>
        )
    }
}

export default CadeAnalyzeRaterComments;


// WEBPACK FOOTER //
// ./src/components/CadeComponent/CadeAnalyzeRaterComments.js